import { render, staticRenderFns } from "./choose-file.vue?vue&type=template&id=43aed94e&lang=pug"
import script from "./choose-file.vue?vue&type=script&lang=js"
export * from "./choose-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports